module.exports = __webpack_public_path__ + "img/cinta-adhesiva-packetgrup.aa0cf696.jpg";